<template>
  <div class="statistics-warpper">
    <div class="bg-white">
      <staticChiose @SearchInfo="SearchInfo"/>
      <div class="flex align-center justify-between margin-top-sm">
        <div class="statistics-item statistics-1">
          <h2><img src="../../assets/img/index-icon1.png" alt="">新增同意改造</h2>
          <div class="item-info">
            <div class="item-num">
              <p>同意户数</p>
              <h3>{{ GZXinZengTongYiShu }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>增长</p>
              <h3>{{ GZXinZengTongYiLv }}%</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>合计</p>
              <h3>{{ GZHeJiTongYiLv }}%</h3>
            </div>
          </div>
        </div>
        <div class="statistics-item statistics-2">
          <h2><img src="../../assets/img/index-icon2.png" alt="">新增物业合同</h2>
          <div class="item-info">
            <div class="item-num">
              <p>份数</p>
              <h3>{{ WYXinZengTongYiShu }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>合计</p>
              <h3>{{ WYHeJiTongYiLv }}%</h3>
            </div>
          </div>
        </div>
        <div class="statistics-item statistics-3">
          <h2><img src="../../assets/img/index-icon3.png" alt="">新增物业费</h2>
          <div class="item-info">
            <div class="item-num">
              <p>新增</p>
              <h3>{{ xinZengWuYeFei }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>年度实收</p>
              <h3>{{ nianDuWuYeShiShou }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>年度应收</p>
              <h3>{{ nianDuWuYeYingShou }}</h3>
            </div>
          </div>
        </div>
        <div class="statistics-item statistics-4">
          <h2><img src="../../assets/img/mj.png" alt="">新增同意综改房屋面积</h2>
          <div class="item-info">
            <div class="item-num">
              <p>房屋面积</p>
              <h3>{{ GZXinZengMianJiTongYiShu }}m²</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>增长</p>
              <h3>{{ GZXinZengMianJiTongYiLv }}%</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>总占比</p>
              <h3>{{ GZHeJiMianJiTongYiLv }}%</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white margin-top-sm">
      <journal/>
    </div>

  </div>
</template>

<script>
import staticChiose from '@/components/static-chiose'
import journal from '@/components/journal'
import {homeTongJi} from "@/api/statistics";
import {zhDate, zhRmb} from "@/utils/utils";

export default {
  name: "index-statistics",
  data() {
    return {
      GZHeJiTongYiLv: 0,
      GZXinZengTongYiLv: 0,
      GZXinZengTongYiShu: 0,
      WYHeJiTongYiLv: 0,
      WYXinZengTongYiLv: 0,
      WYXinZengTongYiShu: 0,
      nianDuWuYeShiShou: 0,
      nianDuWuYeYingShou: 0,
      xinZengWuYeFei: 0,
      GZXinZengMianJiTongYiLv: 0,
      GZXinZengMianJiTongYiShu: 0,
      GZHeJiMianJiTongYiLv: 0,
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "首页统计", false);
  },
  components: {
    staticChiose,
    journal
  },
  methods: {
    async SearchInfo(val) {
      let _data = await homeTongJi(
          1,
          val.dateArr ? zhDate(val.dateArr[0]) + ' 00:00:00' : '',
          val.dateArr ? zhDate(val.dateArr[1]) + ' 23:59:59' : '',
          val.project,
          val.community
      )
      this.GZHeJiTongYiLv = _data.data.GZHeJiTongYiLv * 100
      this.GZXinZengTongYiL = _data.data.GZXinZengTongYiL * 100
      this.GZXinZengTongYiShu = _data.data.GZXinZengTongYiShu

      this.GZXinZengMianJiTongYiLv = _data.data.GZXinZengMianJiTongYiLv*100
      this.GZXinZengMianJiTongYiShu = _data.data.GZXinZengMianJiTongYiShu
      this.GZHeJiMianJiTongYiLv = _data.data.GZHeJiMianJiTongYiLv*100

      this.WYHeJiTongYiLv = _data.data.WYHeJiTongYiLv * 100
      this.WYXinZengTongYiLv = _data.data.WYXinZengTongYiLv * 100
      this.WYXinZengTongYiShu = _data.data.WYXinZengTongYiShu
      this.nianDuWuYeShiShou = zhRmb(_data.data.nianDuWuYeShiShou)
      this.nianDuWuYeYingShou = zhRmb(_data.data.nianDuWuYeYingShou)
      this.xinZengWuYeFei = zhRmb(_data.data.xinZengWuYeFei)
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.statistics-warpper {
  .statistics-item {
    flex-basis: 24%;
    height: 162px;
    border-radius: 8px;
    padding: 10px 0;

    &.statistics-1 {
      background: url(../../assets/img/index-s1.png) no-repeat;
      background-size: 100% 100%;
    }

    &.statistics-2 {
      background: url(../../assets/img/index-s2.png) no-repeat;
      background-size: 100% 100%;
    }

    &.statistics-3 {
      background: url(../../assets/img/index-s3.png) no-repeat;
      background-size: 100% 100%;
    }
    &.statistics-4 {
      background: url(../../assets/img/index-s4.png) no-repeat;
      background-size: 100% 100%;
    }

    h2 {
      display: flex;
      align-items: center;
      margin: 0 30px;
      height: 40px;
      color: #fff;
      font-size: 20px;
      border-bottom: 1px solid #fff;

      img {
        margin-right: 8px;
      }
    }

    .item-info {
      display: flex;
      align-items: center;
      height: 100px;

      .item-num {
        width: 48%;
        text-align: center;
        color: #fff;

        p {
          font-size: 18px;
          line-height: 150%;
        }

        h3 {
          font-size: 28px;
          line-height: 150%;
        }
      }
    }

    i {
      display: block;
      width: 1px;
      height: 52px;
      border: dashed 1px #fff;
      opacity: 0.5;
    }
  }
}
</style>
